// import { useKeycloak } from "@react-keycloak/web";
import {
  BsBoxArrowRight,
  BsFillCartFill,
  BsFillChatSquareFill,
} from "react-icons/bs";
import { Link } from "react-router-dom";
import { useDisconnect } from "wagmi";
import { useAppContext } from "../../../context/app-context";
import { setTokens } from "../../../utils/token-functions";
import MenuIcon from "../../icons/MenuIcon";
import NotificationList from "../../notification-list/NotificationList";
import ProfileImage from "../../profile-image/ProfileImage";
import "./header.css";
// import FilterDropdown from "../../filter-dropdown/FilterDropdown";
// import { useState } from "react";

interface Props {
  verified?: boolean;
}

export default function Header({ verified = true }: Props) {
  const { keycloakProfile, userProfilePic } = useAppContext();
  // const [selectedFilter, setSelectedFilter] = useState<string | null>(
  // const { keycloak } = useKeycloak();
  const { disconnect } = useDisconnect();
  const { isSidebarOpen, showSidebar, hideSidebar, showMessagesModal } =
    useAppContext();

  // const handleFilterSelect = (selectedItem: string | null) => {
  //   setSelectedFilter(selectedItem);
  // };

  return (
    <>
      <header className="d-flex align-items-center justify-content-between position-sticky top-0 px-3 py-2 px-4 py-3 px-lg-5 py-lg-4 mb-md-3 header-bg">
        <div className="d-flex align-items-center">
          {verified && (
            <button
              className="btn p-0 d-none d-md-block d-lg-none"
              onClick={isSidebarOpen ? hideSidebar : showSidebar}
            >
              <span className="me-2">
                <MenuIcon />
              </span>
            </button>
          )}
          <Link to="/dashboard" className={verified ? "" : "pe-none"}>
            <img
              src={process.env.PUBLIC_URL + "/assets/icons/header-logo.png"}
              className="header-logo"
            />
          </Link>
        </div>
        <nav className="d-flex align-items-center">
          <Link
            to="/cart"
            className={`d-flex align-items-center text-decoration-none`}
          >
            <div className="profile-image profile-small me-2 me-md-3 me-lg-4">
              <BsFillCartFill className="notification-icon" />
            </div>
          </Link>
          <div
            className="profile-image profile-small me-2 me-md-3 me-lg-4"
            style={{ cursor: "pointer" }}
            onClick={showMessagesModal}
          >
            <BsFillChatSquareFill />
          </div>
          <NotificationList />
          {verified ? (
            <Link
              to="/my-profile"
              className={`d-flex align-items-center text-decoration-none`}
            >
              <p className="profile-name d-none d-lg-block mb-0">
                {keycloakProfile?.firstName || "Profile"}
              </p>

              <ProfileImage
                profileURL={userProfilePic?.photo}
                firstName={keycloakProfile?.firstName}
                lastName={keycloakProfile?.lastName}
                size="small"
              />
            </Link>
          ) : (
            <button
              className="btn btn-light rounded-pill d-flex align-items-center"
              onClick={() => {
                setTokens("", "");
                disconnect();
              }}
            >
              Logout
              <BsBoxArrowRight className="ms-1" />
            </button>
          )}
        </nav>
      </header>
    </>
  );
}
